<template>
  <div class="px-2">
    <team-item
      :team="team"
      v-for="team in teamTree"
      :key="team.id"
      :selected-org-id="+$route.params.orgId"
      :selected-sub-org-id="+$route.params.subOrgId"
      :expanded-on-launch="expandedOnLaunch"
      :navigate-through-transition="navigateThroughTransition"
      :next-route-name="nextRouteName"
      :next-route-query="nextRouteQuery"
      @select="$emit('select')"
    />
  </div>
</template>

<script>
import TeamItem from '@/components/team/TeamItem'
import TeamMixin from '@/mixins/TeamMixin'

/**
 * This shows collection of orgLike teams as tree view.
 */
export default {
  name: 'TeamsList',
  props: [
    'orgId',
    'expandedOnLaunch',
    'navigateThroughTransition',
    'nextRouteName',
    'nextRouteQuery'
  ],
  mixins: [TeamMixin],
  components: {
    TeamItem
  },
  data() {
    return {
      expand: false
    }
  },
  computed: {
    teamTree() {
      return this.getTeamTree('orgLikeOnly')
    }
  },
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
</style>
